import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Material-UI components
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';

// Material-UI styles
import {withStyles, makeStyles, fade} from '@material-ui/core/styles';
import styles from './styles';

// components
import Topbar from './components/Topbar';
import CDNImage from "../../components/CDNImage";
import bookingSourceImages from "../../containers/GuestPortal/images";
import {isWhite} from '../../libs/utils';

const progressStyles = color => makeStyles({
    barColorPrimary: {
        backgroundColor: fade(color, 0.5)
    },
    page: {
        backgroundColor: color
    }
});


let GuestPortalLayout = (props) => {
    const {
        classes,
        reservation,
        onBack,
        color,
        paintBackground,
        progress,
        isMobile,
        isEmbedded,
        hideTopbar,
        onInfo,
        children,
        useScroll,
        overlay,
    } = props;

    const userCompany = reservation.company || {};
    const logo = bookingSourceImages(reservation);
    const logoInverted = bookingSourceImages(reservation, 1);
    const dynamicClass = progressStyles(color)();

    if (isEmbedded) {
        return (
            <div className={classNames(classes.root, {[dynamicClass.page]: paintBackground})}>
                {!hideTopbar &&
                    <Fragment>
                        <Topbar
                            overlay={overlay}
                            onBack={onBack}
                            onInfo={onInfo}
                            reservation={reservation}
                            isDesktop={true}
                        />
                    </Fragment>
                }
                <Container
                    maxWidth="xs"
                    className={classNames(
                        {[classes.embedded]: isEmbedded},
                        {[dynamicClass.page]: paintBackground},
                    )}
                >
                    {children}
                </Container>
            </div>
        );
    }

    if (isMobile) {
        return (
            <div className={classNames(classes.root, {[dynamicClass.page]: paintBackground})}>
                {!hideTopbar &&
                    <Fragment>
                        <Topbar
                            overlay={overlay}
                            onBack={onBack}
                            onInfo={onInfo}
                            bookingSourceImage={logoInverted}
                            reservation={reservation}
                            rootProps={{style: {backgroundColor: color}}}
                        />
                        {!paintBackground && progress &&
                            <LinearProgress
                                variant="determinate"
                                value={progress}
                                classes={!isWhite(color) ? {barColorPrimary: dynamicClass.barColorPrimary} : null}
                            />
                        }
                    </Fragment>
                }
                <Container maxWidth="xs"
                           className={classNames({[dynamicClass.page]: paintBackground})}
                >
                    {children}
                </Container>
            </div>
        );
    }

    if (!isMobile) {
        return (
            <div
                className={classNames(classes.root, {[classes.rootWithProgress]: !hideTopbar && !paintBackground}, {[dynamicClass.page]: paintBackground})}>

                {!hideTopbar && progress && !paintBackground &&
                    <LinearProgress
                        variant="determinate"
                        value={progress}
                    />
                }

                <Grid container className={classes.grid}>

                    <Grid item xs={6}>

                        {!hideTopbar &&
                            <Topbar
                                overlay={overlay}
                                onBack={onBack}
                                onInfo={onInfo}
                                reservation={reservation}
                                rootProps={{style: {backgroundColor: 'transparent'}}}
                                isDesktop={true}
                            />
                        }

                        <Container
                            maxWidth="sm"
                            className={classNames(
                                {[dynamicClass.page]: paintBackground},
                                {[classes.useScroll]: (typeof useScroll !== 'undefined') ? useScroll : false},
                            )}>
                            {children}
                        </Container>

                        {/*{!hideTopbar && onInfo &&*/}
                        {/*<Footer*/}
                        {/*    onInfo={onInfo}*/}
                        {/*    className={classes.footer}*/}
                        {/*/>*/}
                        {/*}*/}

                    </Grid>

                    <Grid item xs={6} className={classes.listingImageWrapper}>

                        <CDNImage
                            src={reservation.listing_picture_large}
                            className={classes.listingImage}
                            userId={reservation.hid}
                            listingId={reservation.lid}
                            size="original"
                        />

                    </Grid>

                </Grid>
            </div>
        );
    }


};

GuestPortalLayout.propTypes = {
    classes: PropTypes.object.isRequired,
    reservation: PropTypes.object.isRequired,
    onBack: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]).isRequired,
    bookingSourceImage: PropTypes.string,
    color: PropTypes.string.isRequired,
    isMobile: PropTypes.bool.isRequired,
    hideTopbar: PropTypes.bool,
    children: PropTypes.any.isRequired,
    onInfo: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]).isRequired,
    progress: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    paintBackground: PropTypes.bool,
    useScroll: PropTypes.bool,
};

GuestPortalLayout.propDefaults = {
    hideTopbar: false,
    paintBackground: false,
    useScroll: false
};


export {GuestPortalLayout};
export default withStyles(styles)(GuestPortalLayout);
